const variables = {
  mainNavigationLargeHeight: 88,
  mainNavigationLargeMarginTop: 0,
  mainNavigationLargeProfileMenuButtonVariant: 'ghost',
  mainNavigationSmallHeight: 56,
  mainNavigationSmallMarginTop: 8,
  mainNavigationSmallMenuButtonPosition: 'start',
  mainNavigationSmallProfileMenuButtonVariant: 'ghost',
};

export default variables;
